import { RemotePostHelp } from '../../../data/usecases/help/remote-post-help'
import { getUser } from '../../../presentation/utils/storage/user'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
const isTogether = getUser() && getUser()?.team?.games[0]?.type === 'together'

export const makePostHelp = (): RemotePostHelp => {
  const user = getUser() !== undefined
  return new RemotePostHelp(
    isTogether && user
      ? '/helps'
      : '/public/helps',
    makeAxiosHttpClient())
}
